import * as React from 'react'
import styled from 'styled-components'

import * as S from '../../styles'
import TextEllipsis from '../../core/TextEllipsis'

export type PartnerCardProps = {
  href: string
  brand: string
  category: string
  description: string
  url: string
} & React.AnchorHTMLAttributes<HTMLAnchorElement>

function PartnerCardComponent({
  href,
  brand,
  category,
  description,
  url,
  ...extra
}: PartnerCardProps): React.ReactElement<PartnerCardProps> {
  return (
    <S.card.partner.Wrapper>
      <S.card.partner.Container href={href} {...extra}>
        <S.card.partner.Picture url={url}>
          {category && <S.card.partner.Category>{category}</S.card.partner.Category>}
        </S.card.partner.Picture>
        <S.card.partner.Body>
          <S.card.partner.Brand>{brand}</S.card.partner.Brand>
          <S.card.partner.Description>
            <TextEllipsis lines={3} tag="span" ellipsisChars="..." useJsOnly>
              {description}
            </TextEllipsis>
          </S.card.partner.Description>
        </S.card.partner.Body>
      </S.card.partner.Container>
    </S.card.partner.Wrapper>
  )
}

export const PartnerCard = styled(PartnerCardComponent)<PartnerCardProps>``
PartnerCard.displayName = 'PartnerCard'
PartnerCard.defaultProps = {}
